import { lazy } from 'preact/compat';

const redirectTo404 = () => {
    return import(/* webpackChunkName: "404" */ './404');
};

const NotFound = lazy(redirectTo404);

const Faq = lazy(() => {
    return import(/* webpackChunkName: "faq" */ './FAQ').catch(redirectTo404);
});

const Sidebar = lazy(() => {
    return import(/* webpackChunkName: "sidebar" */ './sidebar').catch(redirectTo404);
});

const ContactUs = lazy(() => {
    return import(/* webpackChunkName: "contact-us" */ './contact-us').catch(redirectTo404);
});

const ViewerRatings = lazy(() => {
    return import(/* webpackChunkName: "viewer-ratings" */ './viewer-ratings').catch(redirectTo404);
});

const Rules = lazy(() => {
    return import(/* webpackChunkName: "rules" */ './rules').catch(redirectTo404);
});

const VideoHelp = lazy(() => {
    return import(/* webpackChunkName: "video-help" */ './video-help').catch(redirectTo404);
});

const MailFaq = lazy(() => {
    return import(/* webpackChunkName: "mail-faq" */ './mail-faq').catch(redirectTo404);
});

const AdultRatings = lazy(() => {
    return import(/* webpackChunkName: "adult-ratings" */ './adult-ratings').catch(redirectTo404);
});

const WizardReg = lazy(() => {
    return import(/* webpackChunkName: "wizardreg" */ './wizardreg').catch(redirectTo404);
});

const MailOverview = lazy(() => {
    return import(/* webpackChunkName: "mail-overview" */ './mail-overview').catch(redirectTo404);
});

const MailControl = lazy(() => {
    return import(/* webpackChunkName: "mail-control" */ './mail-control').catch(redirectTo404);
});

const Terms = lazy(() => {
    return import(/* webpackChunkName: "terms" */ './terms').catch(redirectTo404);
});

const PrivacyPolicy = lazy(() => {
    return import(/* webpackChunkName: "privacy-policy" */ './privacy-policy').catch(redirectTo404);
});

const Events = lazy(() => {
    return import(/* webpackChunkName: "events" */ './events').catch(redirectTo404);
});

const ChathostResources = lazy(() => {
    return import(/* webpackChunkName: "chathost-resources" */ './chathost-resources').catch(redirectTo404);
});

const StudioResources = lazy(() => {
    return import(/* webpackChunkName: "studio-resources" */ './studio-resources').catch(redirectTo404);
});

const Logon = lazy(() => {
    return import(/* webpackChunkName: "logon" */ './logon').catch(redirectTo404);
});

const AgeVerification = lazy(() => {
    return import(/* webpackChunkName: "age-verification" */ './age-verification').catch(redirectTo404);
});

const MyAgreements = lazy(() => {
    return import(/* webpackChunkName: "my-agreements" */ './my-agreements').catch(redirectTo404);
});

const PromotionAgreement = lazy(() => {
    return import(/* webpackChunkName: "promotion-agreement" */ './promotion-agreement').catch(redirectTo404);
});

const ConsentAgreement = lazy(() => {
    return import(/* webpackChunkName: "consent-agreement" */ './consent-agreement');
});

const Consent = lazy(() => {
    return import(/* webpackChunkName: "consent" */ './consent');
});

const AgreementDownload = lazy(() => {
    return import(/* webpackChunkName: "agreement-download" */ './agreement-download').catch(redirectTo404);
});

const LuckyChats = lazy(() => {
    return import(/* webpackChunkName: "lucky-chats" */ './lucky-chats').catch(redirectTo404);
});

const Anniversary = lazy(() => {
    return import(/* webpackChunkName: "anniversary" */ './anniversary').catch(redirectTo404);
});

const ValentinesMatch = lazy(() => {
    return import(/* webpackChunkName: "valentines-match" */ './valentines-match').catch(redirectTo404);
});

const StudioLogon = lazy(() => {
    return import(/* webpackChunkName: "studio-logon" */ './studio-logon').catch(redirectTo404);
});

const StudioAccountVerification = lazy(() => {
    return import(/* webpackChunkName: "studio-account-verification" */ './studio-account-verification').catch(redirectTo404);
});

const StudioPrivacyPolicy = lazy(() => {
    return import(/* webpackChunkName: "studio-privacy-policy" */ './studio-privacy-policy').catch(redirectTo404);
});

const StudioTerms = lazy(() => {
    return import(/* webpackChunkName: "studio-terms" */ './studio-terms').catch(redirectTo404);
});

const Account = lazy(() => {
    return import(/* webpackChunkName: "account" */ './account').catch(redirectTo404);
});

const StudioAccount = lazy(() => {
    return import(/* webpackChunkName: "studio-account" */ './studio-account').catch(redirectTo404);
});

const RevenueDetails = lazy(() => {
    return import(/* webpackChunkName: "revenue-details" */ './revenue-details').catch(redirectTo404);
});

const ListPayments = lazy(() => {
    return import(/* webpackChunkName: "list-payments" */ './list-payments').catch(redirectTo404);
});

const StudioRevenueDetails = lazy(() => {
    return import(/* webpackChunkName: "studio-revenue-details" */ './studio-revenue-details').catch(redirectTo404);
});

const StudioListPayments = lazy(() => {
    return import(/* webpackChunkName: "studio-list-payments" */ './studio-list-payments').catch(redirectTo404);
});

export { Faq, Sidebar, ContactUs, ViewerRatings, Rules, VideoHelp, NotFound, MailFaq, AdultRatings, WizardReg, MailOverview, MailControl, Terms, PrivacyPolicy, Events, ChathostResources, Logon, AgeVerification, MyAgreements, PromotionAgreement, AgreementDownload, ConsentAgreement, Consent, StudioResources, LuckyChats, Anniversary, ValentinesMatch, StudioLogon, StudioAccountVerification, StudioPrivacyPolicy, StudioTerms, Account, StudioAccount, RevenueDetails, ListPayments, StudioRevenueDetails, StudioListPayments };
